import { FC, memo, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Notification, NotificationTypeText } from '@app/models';
import { dateFormat } from '@app/helpers';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { cn } from 'lib/utils';

interface INotificationItem {
  notification: Notification;
  className?: string;
}

const NotificationItem: FC<INotificationItem> = (props) => {
  const { notification, className } = props;
  const location = useLocation();

  const path = useMemo(() => '/profile/notification', [location]);

  return (
    <li
      className={cn(
        'flex items-start justify-between p-3 rounded-lg hover:bg-muted/50 transition-colors',
        className
      )}
    >
      <div className="flex-1 min-w-0 mr-3">
        <h4 className="text-sm font-medium text-foreground mb-1 truncate">
          {NotificationTypeText[notification.type]}
        </h4>
        <p className="text-xs text-muted-foreground mb-2 line-clamp-2">
          {notification.message}
        </p>
        <Button
          variant="link"
          size="sm"
          asChild
          className="h-auto p-0 text-xs text-primary hover:text-primary/80"
        >
          <Link to={path}>Перейти</Link>
        </Button>
      </div>
      <div className="flex flex-col items-end text-right">
        <p className="text-xs text-muted-foreground mb-1">
          {dateFormat(notification.createdAt)}
        </p>
        <span className="text-xs text-muted-foreground mb-1">
          {dateFormat(notification.createdAt, 'hh:mm')}
        </span>
        <Badge variant="secondary" className="text-xs px-1.5 py-0.5">
          1
        </Badge>
      </div>
    </li>
  );
};

export default memo(NotificationItem);
